__turbopack_context__.v({
  "close": "Drawer-module__Jc2nYa__close",
  "closeButton": "Drawer-module__Jc2nYa__closeButton",
  "colorYellow": "Drawer-module__Jc2nYa__colorYellow",
  "content": "Drawer-module__Jc2nYa__content",
  "header": "Drawer-module__Jc2nYa__header",
  "inline": "Drawer-module__Jc2nYa__inline",
  "left": "Drawer-module__Jc2nYa__left",
  "main": "Drawer-module__Jc2nYa__main",
  "modalViewport": "Drawer-module__Jc2nYa__modalViewport",
  "right": "Drawer-module__Jc2nYa__right",
  "small": "Drawer-module__Jc2nYa__small",
  "title": "Drawer-module__Jc2nYa__title",
  "viewport": "Drawer-module__Jc2nYa__viewport",
  "viewportBase": "Drawer-module__Jc2nYa__viewportBase",
});
